import Vue from "vue";
import Router from "vue-router";

import Layout from "@/components/Layout/Layout";
// import Page from "@/components/Layout/Page";

// ERROR
import P403 from "@/pages/Error/403/403";
import ErrorPage from "@/pages/Error/Error";

// PUBLIC
import login from "@/pages/public/login/login";

// DASHBOARD
import dashboard from "@/pages/dashboard/dashboard";

//Master
import barang from "@/pages/dashboard/master/barang/barang";
import brand from "@/pages/dashboard/master/brand/brand";
import canvas from "@/pages/dashboard/master/canvas/canvas";
import depo from "@/pages/dashboard/master/depo/depo";
import mitra from "@/pages/dashboard/master/mitra/mitra";
import perusahaan from "@/pages/dashboard/master/perusahaan/perusahaan";
import principal from "@/pages/dashboard/master/principal/principal";
import salesman from "@/pages/dashboard/master/salesman/salesman";
import segmen from "@/pages/dashboard/master/segmen/segmen";
import tipeHarga from "@/pages/dashboard/master/tipe-harga/tipe-harga";

//MONITORING
import monitoringOta from "@/pages/dashboard/monitoring/ota/monitoring-ota";
import monitoringOutletCondition from "@/pages/dashboard/monitoring/outlet-condition/monitoring-outlet-condition";
import monitoringPareto from "@/pages/dashboard/monitoring/pareto/monitoring-pareto";
import monitoringPro from "@/pages/dashboard/monitoring/pro/monitoring-pro";
import quickSearch from "@/pages/dashboard/monitoring/quick-search/quick-search";
import monitoringRetur from "@/pages/dashboard/monitoring/retur/monitoring-retur";
import monitoringSalesman from "@/pages/dashboard/monitoring/salesman/monitoring-salesman";
import monitoringServiceLevel from "@/pages/dashboard/monitoring/service-level-monitoring/service-level-monitoring";
import monitoringStockTmp from "@/pages/dashboard/monitoring/stock-tmp/monitoring-stock-tmp";

// SALES
import tim from "@/pages/dashboard/master/tim/tim";
import tokoUnverified from "@/pages/dashboard/sales/toko-unverified/toko-unverified";
import tokoUpdate from "@/pages/dashboard/sales/toko-update/toko-update";
import toko from "@/pages/dashboard/sales/toko/toko";

import limitKredit from "@/pages/dashboard/sales/laporan-limit-kredit/laporan-limit-kredit";

import penjualan from "@/pages/dashboard/sales/penjualan/penjualan";
import printInvoice from "@/pages/dashboard/sales/penjualan/print/invoice";
import printInvoiceItems from "@/pages/dashboard/sales/penjualan/print/invoice-items";
import printInvoiceObor from "@/pages/dashboard/sales/penjualan/print/invoice-obor";
import printInvoice2 from "@/pages/dashboard/sales/penjualan/print/invoice2";
import printProformaInvoiceItems from "@/pages/dashboard/sales/penjualan/print/proforma-invoice-items";

import addPromo from "@/pages/dashboard/sales/promo/add";
import editPromo from "@/pages/dashboard/sales/promo/edit";
import promo from "@/pages/dashboard/sales/promo/promo";
import printRealisasiPenjualan from "@/pages/dashboard/sales/realisasi-program/print/realisasi-program";
import realisasiProgram from "@/pages/dashboard/sales/realisasi-program/realisasi-program";
import returPenjualan from "@/pages/dashboard/sales/retur-penjualan/retur-penjualan";
import salesOrder from "@/pages/dashboard/sales/sales-order";
import sharingPromo from "@/pages/dashboard/sales/sharing-promo/sharing-promo";

import returPenjualanGroupIndex from "@/pages/dashboard/sales/retur-penjualan-group/index";
import returPenjualanGroupPrint from "@/pages/dashboard/sales/retur-penjualan-group/print/index";
import returPenjualanGroup from "@/pages/dashboard/sales/retur-penjualan-group/retur-penjualan-group";
import returPenjualanUngroup from "@/pages/dashboard/sales/retur-penjualan-group/retur-penjualan-ungroup";

import printReturPenjualan from "@/pages/dashboard/sales/retur-penjualan/print/retur-penjualan";
import printReturPenjualanBaru from "@/pages/dashboard/sales/retur-penjualan/print/retur-penjualan-baru";
import importTargetSalesman from "@/pages/dashboard/sales/target-sales/import/import-target-salesman";
import targetsalesman from "@/pages/dashboard/sales/target-sales/target-sales";

import formTargetSales from "@/pages/dashboard/sales/target-sales/form";

import delivery from "@/pages/dashboard/sales/delivery-penjualan/delivery-penjualan";
import exportDataPenjualan from "@/pages/dashboard/sales/export-data-penjualan/export-data-penjualan";
import detailOmsetToko from "@/pages/dashboard/sales/laporan-omset-toko/detail-omset-toko";
import omsetToko from "@/pages/dashboard/sales/laporan-omset-toko/laporan-omset-toko";
import detailRankingBarang from "@/pages/dashboard/sales/laporan-ranking-barang/detail-ranking-barang";
import printReturSegmen from "@/pages/dashboard/sales/laporan-retur-segmen/print/laporan-retur-segmen";
import posisiPenjualan from "@/pages/dashboard/sales/posisi-penjualan/posisi-penjualan";
import kuotaSales from "@/pages/dashboard/sales/kuota-sales/kuota-sales";

//Rekapitulasi DO
import printRekapitulasiDO from "@/pages/dashboard/sales/rekapitulasi-do/print/rekapitulasi";
import rekapitulasiDO from "@/pages/dashboard/sales/rekapitulasi-do/rekapitulasi-do";

// REPORT
import laporanGrossProfit from "@/pages/dashboard/finance/laporan-gross-profit/laporan-gross-profit";
import laporanMonitoringStock from "@/pages/dashboard/inventory/laporan-monitoring-stock/laporan-monitoring-stock";
import laporanMutasiBarang from "@/pages/dashboard/inventory/laporan-mutasi-barang/laporan-mutasi-barang";
import laporanSuggestOrder from "@/pages/dashboard/inventory/laporan-suggest-order/laporan-suggest-order";
import trackingReturSales from "@/pages/dashboard/reports/retur-sales/retur-sales";
import laporanSLASales from "@/pages/dashboard/reports/sla-sales/sla-sales";
import serviceLevelSalesMT from "@/pages/dashboard/reports/service-level-sales-mt/service-level-sales-mt";
import trackingOutletActive from "@/pages/dashboard/reports/tracking-outlet-active/tracking-outlet-active";
import trackingSalesTarget from "@/pages/dashboard/reports/tracking-sales-target/tracking-sales-target";
import laporanJurnalPenjualan from "@/pages/dashboard/sales/jurnal-penjualan/jurnal-penjualan";
import printJurnalPenjualan from "@/pages/dashboard/sales/jurnal-penjualan/print/jurnal-penjualan";
import laporanAktual from "@/pages/dashboard/sales/laporan-aktual/laporan-aktual";
import laporanDistributionHistory from "@/pages/dashboard/sales/laporan-distribution-history/laporan-distribution-history";
import laporanEC from "@/pages/dashboard/sales/laporan-ec/laporan-ec";
import pembagianPromo from "@/pages/dashboard/sales/laporan-pembagian-promo/laporan-pembagian-promo";
import laporanPenjualanHarian from "@/pages/dashboard/sales/laporan-penjualan-harian/laporan-penjualan-harian";
import laporanRankingBarang from "@/pages/dashboard/sales/laporan-ranking-barang/laporan-ranking-barang";
import laporanReturPenjualan from "@/pages/dashboard/sales/laporan-retur-penjualan/laporan-retur-penjualan";
import laporanReturSegmen from "@/pages/dashboard/sales/laporan-retur-segmen/laporan-retur-segmen";
import laporanSalesDaily from "@/pages/dashboard/sales/laporan-sales-daily/laporan-sales-daily";
import laporanSalesDistributor from "@/pages/dashboard/sales/laporan-sales-distributor/laporan-sales-distributor";
import laporanSTD from "@/pages/dashboard/sales/laporan-sales-to-distributor/laporan-sales-to-distributor";
import laporanSTT from "@/pages/dashboard/sales/laporan-sales-to-trade/laporan-sales-to-trade";
import laporanSales from "@/pages/dashboard/sales/laporan-sales/laporan-sales";
import kunjungan from "@/pages/dashboard/sales/laporan-salesman/kunjungan";
import laporanSTTPajak from "@/pages/dashboard/sales/laporan-stt-pajak/laporan-stt-pajak";
import laporanTotalReturDaily from "@/pages/dashboard/sales/laporan-total-retur-daily/laporan-total-retur-daily";
import laporanTotalReturDistributor from "@/pages/dashboard/sales/laporan-total-retur-distributor/laporan-total-retur-distributor";
import laporanTotalRetur from "@/pages/dashboard/sales/laporan-total-retur/laporan-total-retur";
import trackingServiceLevelSales from "@/pages/dashboard/reports/tracking-service-level-sales/tracking-service-level-sales";
import laporanKunjunganSalesman from "@/pages/dashboard/reports/kunjungan-salesman/kunjungan-salesman";

//Mitra
// import mitraPelunasanPiutang from "@/pages/dashboard/mitra/pelunasan/pelunasan";
import mitraKonversiPajakCoretax from "@/pages/dashboard/external/coretax/faktur-keluaran";
import mitraDataPiutang from "@/pages/dashboard/mitra/data-piutang/data-piutang";
import mitraLaporanAktual from "@/pages/dashboard/mitra/laporan-aktual/laporan-aktual";
import mitraLaporanPenjualanHarian from "@/pages/dashboard/mitra/laporan-penjualan-harian/laporan-penjualan-harian";
import mitraLaporanPosisiStock from "@/pages/dashboard/mitra/laporan-posisi-stock/laporan-posisi-stock";
import mitraLaporanReturPenjualan from "@/pages/dashboard/mitra/laporan-retur-penjualan/laporan-retur-penjualan";
import mitraSalesToTrade from "@/pages/dashboard/mitra/laporan-sales-to-trade/laporan-sales-to-trade";
import mitraPenjualan from "@/pages/dashboard/mitra/penjualan/penjualan";
import mitraRekapitulasiPenagihan from "@/pages/dashboard/mitra/rekapitulasi-penagihan/rekapitulasi";
import mitraReturPenjualan from "@/pages/dashboard/mitra/retur-penjualan/retur-penjualan";

// INVENTORY
import mutasiBarang from "@/pages/dashboard/inventory/mutasi-barang/mutasi-barang";
import printMutasi from "@/pages/dashboard/inventory/mutasi-barang/print/mutasi";
import penerimaanBarang from "@/pages/dashboard/inventory/penerimaan-barang/penerimaan-barang";
import printPenerimaanBarang from "@/pages/dashboard/inventory/penerimaan-barang/print/penerimaan-barang";
import PrintStockOpname from "@/pages/dashboard/inventory/stock-opname/print/print-stock-opname";
import StockOpname from "@/pages/dashboard/inventory/stock-opname/stock-opname";
import stock from "@/pages/dashboard/inventory/stock/stock";

import adjustmentBarang from "@/pages/dashboard/inventory/adjustment-barang/adjustment-barang";
import printAdjustment from "@/pages/dashboard/inventory/adjustment-barang/print/adjustment";
import laporanAdjustmentBarang from "@/pages/dashboard/inventory/laporan-adjustment-barang/laporan-adjustment-barang";

import deliveryOrder from "@/pages/dashboard/inventory/delivery-order/do";
import gudang from "@/pages/dashboard/inventory/gudang/gudang";
import laporanPelunasanDriver from "@/pages/dashboard/inventory/laporan-pelunasan-driver/laporan-pelunasan-driver";
import laporanPosisiStock from "@/pages/dashboard/inventory/laporan-posisi-stock/laporan-posisi-stock";
import PrintPosisiStockGudang from "@/pages/dashboard/inventory/posisi-stock-gudang/print/print-posisi-stock-gudang";
import riwayatBarang from "@/pages/dashboard/inventory/riwayat-barang/riwayat-barang";

//Rekapitulasi DO
import printRekapitulasiDODriver from "@/pages/dashboard/sales/rekapitulasi-do/print/rekapitulasi";
import rekapitulasiDODriver from "@/pages/dashboard/sales/rekapitulasi-do/rekapitulasi-do";

//Distribution Plan
import distributionPlanPenjualan from "@/pages/dashboard/inventory/distribution_plan/penjualan/penjualan";

import distributionPlanPlanedDriver from "@/pages/dashboard/inventory/distribution_plan/penjualan/planed-driver";
import distributionPlanReportDriver from "@/pages/dashboard/inventory/distribution_plan/penjualan/report-driver";
import distributionPlanServiceLevel from "@/pages/dashboard/inventory/distribution_plan/penjualan/service-level";

import distributionPlan_DeliverReport from "@/pages/dashboard/inventory/distribution_plan/delivery-report/delivery-report";
import distributionPlanPenjualanTerjadwal from "@/pages/dashboard/inventory/distribution_plan/penjualan/pengiriman-penjualan-terjadwal";

//Realisasi DO
import printReportRealisasiDO from "@/pages/dashboard/inventory/realisasi-do/print/report";
import distributionPlan_ReportRealisasiDO from "@/pages/dashboard/inventory/realisasi-do/realisasi-do";

// FINANCE
import FormInvoiceNote from "@/pages/dashboard/finance/invoice-note/form";
import InvoiceNote from "@/pages/dashboard/finance/invoice-note/invoice-note";
import detailRankingPiutang from "@/pages/dashboard/finance/laporan-ranking-piutang/detail-ranking-piutang";
import laporanRankingPiutang from "@/pages/dashboard/finance/laporan-ranking-piutang/laporan-ranking-piutang";
import piutang from "@/pages/dashboard/finance/pelunasan/pelunasan";
import printSemuaInvoice from "@/pages/dashboard/finance/pelunasan/print/semua-invoice";
import pelunasan from "@/pages/dashboard/finance/pelunasan/semua-invoice";
import rekapitulasiPenagihan from "@/pages/dashboard/finance/rekapitulasi-penagihan/rekapitulasi";
import returKlaim from "@/pages/dashboard/finance/retur-report/retur-report";
import printSuratTagihan from "@/pages/dashboard/finance/surat-tagihan/print";
import suratPenagihan from "@/pages/dashboard/finance/surat-tagihan/surat-tagihan";

// PURCHASE
import PelunasanPembelian from "@/pages/dashboard/purchase/pelunasan/pelunasan";
import TambahDataPembelian from "@/pages/dashboard/purchase/pembelian/add";
import EditDataPembelian from "@/pages/dashboard/purchase/pembelian/edit";
import DataPembelian from "@/pages/dashboard/purchase/pembelian/pembelian";

// EXTERNAL
import bridging from "@/pages/dashboard/external/bridging/bridging";
import mappingExternal from "@/pages/dashboard/external/bridging/mapping";
import konversiPajakCoretax from "@/pages/dashboard/external/coretax/faktur-keluaran";
import dkImport from "@/pages/dashboard/external/dk/import";
import dkReport from "@/pages/dashboard/external/dk/report";
import espt from "@/pages/dashboard/external/espt/espt";
import exportKino from "@/pages/dashboard/external/export-kino/export-kino";
import exportMarsEnhanced from "@/pages/dashboard/external/export-mars-enhanced/export-mars-enhanced";
import exportMars from "@/pages/dashboard/external/export-mars/export-mars";
import importPajak from "@/pages/dashboard/external/import-pajak/import-pajak";
import kinoBridging from "@/pages/dashboard/external/kino-bridging/kino";
import konversiPajak from "@/pages/dashboard/external/konversi-pajak/konversi-pajak";
import mappingMars from "@/pages/dashboard/external/mapping-mars/mapping-mars";
import importOrderKino from "@/pages/dashboard/external/order-kino/order-kino";
import importOrderSan from "@/pages/dashboard/external/order-san/import-order-san";
import importOrderSosro from "@/pages/dashboard/external/order-sosro/import-order-sosro";
import importRekapPajak from "@/pages/dashboard/external/rekap-pajak/import-rekap-pajak";
import sttEnhanced from "@/pages/dashboard/external/stt-enhanced/stt-enhanced";
import surveyHarga from "@/pages/dashboard/external/survey-harga/survey-harga";

// ADMINISTRATOR
import apiRequestHistory from "@/pages/dashboard/administrator/api-request-history/api-request-history";
import driver from "@/pages/dashboard/administrator/driver/driver";
import dataGrupToko from "@/pages/dashboard/administrator/grup-outlet/data-grup-outlet";
import grupToko from "@/pages/dashboard/administrator/grup-outlet/tambah-grup-outlet";
import hariEfektif from "@/pages/dashboard/administrator/hari-efektif/hari-efektif";
import kendaraan from "@/pages/dashboard/administrator/kendaraan/kendaraan";
import permissions from "@/pages/dashboard/administrator/permissions/permissions";
import UserPrincipal from "@/pages/dashboard/administrator/principal/user-principal";
import reference from "@/pages/dashboard/administrator/reference/reference";
import role from "@/pages/dashboard/administrator/role/role";
import SelectOption from "@/pages/dashboard/administrator/select-option/select-option";
import WhitelistOutlet from "@/pages/dashboard/administrator/toko-no-limit/toko-no-limit";
import users from "@/pages/dashboard/administrator/users/users";
import vendor from "@/pages/dashboard/administrator/vendor/vendor";

// REPORT
import laporanInsentifSalesman from "@/pages/dashboard/reports/insentif/laporan-insentif-salesman";
import reportSKU from "@/pages/dashboard/reports/sku/sku";

// TESTING
import reportStockV2 from "@/pages/dashboard/external/report-stock-v2/report-stock-v2.vue";
import testingDashboard from "@/pages/dashboard/testing/dashboard/dashboard";
import testingFakturPajak from "@/pages/dashboard/testing/faktur-pajak-search/faktur-pajak-search";
import testingSalesToTrade from "@/pages/dashboard/testing/laporan-sales-to-trade/laporan-sales-to-trade";
import testingPosisiStock from "@/pages/dashboard/testing/posisi-stock/posisi-stock";
import testingModule from "@/pages/dashboard/testing/test/test";

import approval from "@/pages/dashboard/approval.vue";
import billingHistory from "@/pages/dashboard/billing/history.vue";
import billingWaiting from "@/pages/dashboard/billing/waiting.vue";
import pelunasanCanvass from "@/pages/dashboard/finance/pelunasan-canvass/pelunasan-canvass.vue";
import pelunasanDriver from "@/pages/dashboard/finance/pelunasan-driver/pelunasan-driver.vue";

Vue.use(Router);

let routes = new Router({
  mode: "history",
  routes: [
    // PUBLIC
    {
      path: "/",
      name: "Login",
      component: login,
    },

    { path: "*", name: "Error", component: ErrorPage },
    { path: "/403", name: "403", component: P403 },

    // PRIVATE
    {
      path: "/dashboard",
      component: Layout,
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          name: "Dashboard",
          component: dashboard,
        },

        //Master
        {
          path: "master/perusahaan",
          name: "Perusahaan",
          component: perusahaan,
        },
        {
          path: "master/barang",
          name: "Barang",
          component: barang,
        },
        {
          path: "master/brand",
          name: "Brand",
          component: brand,
        },
        {
          path: "master/canvas",
          name: "Canvas",
          component: canvas,
        },
        {
          path: "master/depo",
          name: "Depo",
          component: depo,
        },
        {
          path: "master/principal",
          name: "Principal",
          component: principal,
        },
        {
          path: "master/salesman",
          name: "Salesman",
          component: salesman,
        },
        {
          path: "master/segmen",
          name: "Segmen",
          component: segmen,
        },
        {
          path: "master/tipe-harga",
          name: "TipeHarga",
          component: tipeHarga,
        },

        {
          path: "master/tim",
          name: "Tim",
          component: tim,
        },

        {
          path: "master/mitra",
          name: "Mitra",
          component: mitra,
        },

        //MONITORING
        {
          path: "monitoring/salesman",
          name: "MonitoringSalesman",
          component: monitoringSalesman,
        },
        {
          path: "monitoring/pareto",
          name: "MonitoringPareto",
          component: monitoringPareto,
        },
        {
          path: "monitoring/retur",
          name: "MonitoringRetur",
          component: monitoringRetur,
        },
        {
          path: "monitoring/ota",
          name: "MonitoringOta",
          component: monitoringOta,
        },
        {
          path: "monitoring/pro",
          name: "MonitoringPro",
          component: monitoringPro,
        },
        {
          path: "monitoring/stock-tmp",
          name: "MonitoringStockTmp",
          component: monitoringStockTmp,
        },
        {
          path: "monitoring/service-level",
          name: " MonitoringServiceLevel",
          component: monitoringServiceLevel,
        },
        {
          path: "monitoring/outlet-condition",
          name: " MonitoringOutletCondition",
          component: monitoringOutletCondition,
        },
        {
          path: "monitoring/quick-search",
          name: "QuickSearch",
          component: quickSearch,
        },
        //REPORTS
        {
          path: "reports/laporan-aktual",
          name: "LaporanAktual",
          component: laporanAktual,
        },
        {
          path: "reports/laporan-gross-profit",
          name: "Laporan Gross Profit",
          component: laporanGrossProfit,
        },
        {
          path: "reports/laporan-sales-to-trade",
          name: "LaporanSTT",
          component: laporanSTT,
        },
        {
          path: "reports/laporan-sales",
          name: "LaporanSales",
          component: laporanSales,
        },
        {
          path: "reports/laporan-sales-daily",
          name: "LaporanSalesDaily",
          component: laporanSalesDaily,
        },
        {
          path: "reports/laporan-sales-distributor",
          name: "LaporanSalesDistributor",
          component: laporanSalesDistributor,
        },
        {
          path: "reports/laporan-ec",
          name: "LaporanEC",
          component: laporanEC,
        },
        {
          path: "reports/laporan-stt-pajak",
          name: "LaporanSTTPajak",
          component: laporanSTTPajak,
        },
        {
          path: "reports/laporan-sales-to-distributor",
          name: "LaporanSTD",
          component: laporanSTD,
        },
        {
          path: "reports/laporan-penjualan-harian",
          name: "LaporanPenjualanHarian",
          component: laporanPenjualanHarian,
        },
        {
          path: "reports/laporan-jurnal-penjualan",
          name: "LaporanJurnalPenjualan",
          component: laporanJurnalPenjualan,
        },
        {
          path: "sales/print-jurnal-penjualan",
          name: "PrintJurnalPenjualan",
          component: printJurnalPenjualan,
        },

        {
          path: "reports/laporan-retur-penjualan",
          name: "LaporanReturPenjualan",
          component: laporanReturPenjualan,
        },
        {
          path: "reports/laporan-total-retur",
          name: "LaporanTotalRetur",
          component: laporanTotalRetur,
        },
        {
          path: "reports/laporan-total-retur-daily",
          name: "LaporanTotalReturDaily",
          component: laporanTotalReturDaily,
        },
        {
          path: "reports/laporan-total-retur-distributor",
          name: "LaporanTotalReturDistributor",
          component: laporanTotalReturDistributor,
        },
        {
          path: "reports/laporan-retur-segmen",
          name: "LaporanReturSegmen",
          component: laporanReturSegmen,
        },
        {
          path: "reports/laporan-ranking-barang",
          name: "LaporanRankingBarang",
          component: laporanRankingBarang,
        },
        {
          path: "reports/laporan-omset-toko",
          name: "LaporanOmsetToko",
          component: omsetToko,
        },
        {
          path: "reports/pembagian-promo",
          name: "PembagianPromo",
          component: pembagianPromo,
        },
        {
          path: "reports/laporan-monitoring-stock",
          name: "LaporanMonitoringStock",
          component: laporanMonitoringStock,
        },
        {
          path: "reports/laporan-suggest-order",
          name: "LaporanSuggestOrder",
          component: laporanSuggestOrder,
        },
        {
          path: "reports/laporan-mutasi-barang",
          name: "LaporanMutasiBarang",
          component: laporanMutasiBarang,
        },
        {
          path: "reports/laporan-insentif-salesman",
          name: "LaporanInsentifSalesman",
          component: laporanInsentifSalesman,
        },
        {
          path: "reports/laporan-distribution-history",
          name: "LaporanDistributionHistory",
          component: laporanDistributionHistory,
        },
        {
          path: "reports/laporan-salesman",
          component: Layout,
          children: [
            {
              path: "kunjungan",
              name: "KunjunganSaleman",
              component: kunjungan,
            },
          ],
        },
        {
          path: "reports/tracking-outlet-active",
          name: "TrackingOutletActive",
          component: trackingOutletActive,
        },
        {
          path: "reports/laporan-retur-sales",
          name: "LaporanReturSales",
          component: trackingReturSales,
        },
        {
          path: "reports/tracking-sales-target",
          name: "TrackingSalesTarget",
          component: trackingSalesTarget,
        },
        {
          path: "reports/laporan-sla-sales",
          name: "LaporanSLASales",
          component: laporanSLASales,
        },
        {
          path: "reports/service-level/sales-mt",
          name: "ServiceLevelSalesMT",
          component: serviceLevelSalesMT,
        },
        {
          path: "reports/tracking-service-level-sales",
          name: "trackingServiceLevelSales",
          component: trackingServiceLevelSales,
        },
        {
          path: "reports/kunjungan-salesman",
          name: "LaporanKunjunganSalesman",
          component: laporanKunjunganSalesman,
        },

        //SALES
        {
          path: "sales/toko",
          name: "Toko",
          component: toko,
        },
        {
          path: "sales/toko/update",
          name: "Toko Update",
          component: tokoUpdate,
        },
        {
          path: "sales/toko/unverified",
          name: "Toko Unverified",
          component: tokoUnverified,
        },
        {
          path: "sales/penjualan",
          name: "Penjualan",
          component: penjualan,
        },
        {
          path: "sales/delivery-penjualan",
          name: "DeliveryPenjualan",
          component: delivery,
        },
        {
          path: "sales/print-invoice",
          name: "PrintInvoice",
          component: printInvoice,
        },
        {
          path: "sales/print-invoice-2",
          name: "PrintInvoice2",
          component: printInvoice2,
        },
        {
          path: "sales/print-invoice-items",
          name: "printInvoiceItems",
          component: printInvoiceItems,
        },
        {
          path: "sales/print-proforma-invoice-items",
          name: "printProformaInvoiceItems",
          component: printProformaInvoiceItems,
        },
        {
          path: "sales/print-invoice-obor",
          name: "PrintInvoiceObor",
          component: printInvoiceObor,
        },

        {
          path: "sales/sales-order",
          name: "SalesOrder",
          component: salesOrder,
        },
        {
          path: "sales/promo",
          name: "Promo",
          component: promo,
        },
        {
          path: "sales/promo/add",
          name: "Add Promo",
          component: addPromo,
        },
        {
          path: "sales/promo/:id/edit",
          name: "Edit Promo",
          component: editPromo,
        },
        {
          path: "sales/sharing-promo",
          name: "SharingPromo",
          component: sharingPromo,
        },
        {
          path: "sales/realisasi-program",
          name: "RealisasiProgramm",
          component: realisasiProgram,
        },
        {
          path: "sales/realisasi-program/print",
          name: "PrintRealisasiPenjualan",
          component: printRealisasiPenjualan,
        },
        {
          path: "sales/retur-penjualan",
          name: "ReturPenjualan",
          component: returPenjualan,
        },
        {
          path: "sales/retur-penjualan",
          name: "ReturPenjualanGroupIndex",
          component: returPenjualanGroupIndex,
          children: [
            {
              path: "ungroup",
              name: "ReturPenjualanUngroup",
              component: returPenjualanUngroup,
            },
            {
              path: "group",
              name: "ReturPenjualanGroup",
              component: returPenjualanGroup,
            },
          ],
        },
        {
          path: "sales/retur-penjualan-group/print",
          name: "PrintReturPenjualanGroup",
          component: returPenjualanGroupPrint,
        },
        {
          path: "sales/retur-penjualan/print",
          name: "PrintReturPenjualan",
          component: printReturPenjualan,
        },
        {
          path: "sales/retur-penjualan/print-baru",
          name: "printReturPenjualanBaru",
          component: printReturPenjualanBaru,
        },
        {
          path: "sales/detail-omset-toko",
          name: "DetailOmsetToko",
          component: detailOmsetToko,
        },
        {
          path: "sales/target-salesman",
          name: "Target Salesman",
          component: targetsalesman,
        },
        {
          path: "sales/target-salesman/add",
          name: "Tambah Target Salesman",
          component: formTargetSales,
        },
        {
          path: "sales/target-salesman/import",
          name: "ImportTargetSalesman",
          component: importTargetSalesman,
        },
        {
          path: "sales/rekapitulasi-do",
          name: "rekapitulasiDO",
          component: rekapitulasiDO,
        },
        {
          path: "sales/rekapitulasi-do/print",
          name: "printRekapitulasiDO",
          component: printRekapitulasiDO,
        },
        {
          path: "sales/print-retur-segmen",
          name: "printReturSegmen",
          component: printReturSegmen,
        },
        {
          path: "sales/export-data-penjualan",
          name: "ExportDataPenjualan",
          component: exportDataPenjualan,
        },
        {
          path: "sales/posisi-penjualan",
          name: "PosisiDataPenjualan",
          component: posisiPenjualan,
        },
        {
          path: "sales/detail-ranking-barang",
          name: "DetailRankingBarang",
          component: detailRankingBarang,
        },
        {
          path: "sales/limit-kredit",
          name: "LimitKredit",
          component: limitKredit,
        },
        {
          path: "sales/kuota-sales",
          name: "KuotaSales",
          component: kuotaSales,
        },

        // MITRA
        {
          path: "mitra/penjualan",
          name: "MitraPenjualan",
          component: mitraPenjualan,
        },
        {
          path: "mitra/pelunasan",
          name: "MitraPelunasan",
          component: pelunasan,
        },
        {
          path: "mitra/data-piutang",
          name: "MitraDataPiutang",
          component: mitraDataPiutang,
        },
        {
          path: "mitra/retur-penjualan",
          name: "MitraReturPenjualan",
          component: mitraReturPenjualan,
        },
        {
          path: "mitra/laporan-sales-to-trade",
          name: "MitraSalesToTrade",
          component: mitraSalesToTrade,
        },
        {
          path: "mitra/laporan-retur-penjualan",
          name: "MitraLaporanReturPenjualan",
          component: mitraLaporanReturPenjualan,
        },
        {
          path: "mitra/laporan-aktual",
          name: "MitraLaporanAktual",
          component: mitraLaporanAktual,
        },
        {
          path: "mitra/laporan-penjualan-harian",
          name: "MitraLaporanPenjualanHarian",
          component: mitraLaporanPenjualanHarian,
        },
        {
          path: "mitra/rekapitulasi-penagihan",
          name: "MitraRekapitulasiPenagihan",
          component: mitraRekapitulasiPenagihan,
        },
        {
          path: "mitra/laporan-posisi-stock",
          name: "mitraLaporanPosisiStockMitra",
          component: mitraLaporanPosisiStock,
        },
        {
          path: "mitra/konversi-pajak-coretax",
          name: "mitraKonversiPajakCoretax",
          component: mitraKonversiPajakCoretax,
        },
        {
          path: "mitra/posisi-stock-gudang-mitra",
          name: "PosisiStockGudangMitra",
          // component: posisiStockGudangMitra,
          redirect: "inventory/laporan-posisi-stock",
        },

        // INVENTORY
        {
          path: "inventory/stock",
          name: "Stock",
          component: stock,
        },
        {
          path: "inventory/stock-opname",
          name: "StockOpname",
          component: StockOpname,
        },
        {
          path: "inventory/stock-opname/print",
          name: "PrintStockOpname",
          component: PrintStockOpname,
        },
        {
          path: "inventory/penerimaan-barang",
          name: "PenerimaanBarang",
          component: penerimaanBarang,
        },
        {
          path: "inventory/penerimaan-barang/print",
          name: "PrintPenerimaanBarang",
          component: printPenerimaanBarang,
        },
        {
          path: "inventory/mutasi-barang",
          name: "MutasiBarang",
          component: mutasiBarang,
        },
        {
          path: "inventory/mutasi-barang/print",
          name: "PrintMutasi",
          component: printMutasi,
        },
        {
          path: "inventory/adjustment-barang",
          name: "AdjustmentBarang",
          component: adjustmentBarang,
        },
        {
          path: "inventory/adjustment-barang/print",
          name: "PrintAdjustment",
          component: printAdjustment,
        },
        {
          path: "inventory/laporan-adjustment-barang",
          name: "LaporanAdjustmentBarang",
          component: laporanAdjustmentBarang,
        },
        {
          path: "inventory/gudang",
          name: "Gudang",
          component: gudang,
        },
        {
          path: "inventory/laporan-posisi-stock",
          name: "LaporanPosisiStock",
          component: laporanPosisiStock,
        },
        {
          path: "inventory/riwayat-barang",
          name: "RiwayatBarang",
          component: riwayatBarang,
        },
        {
          path: "inventory/delivery-order",
          name: "DeliveryOrder",
          component: deliveryOrder,
        },
        {
          path: "inventory/posisi-stock-gudang",
          name: "LaporanPosisiStockGudang",
          redirect: "inventory/laporan-posisi-stock",
        },
        {
          path: "inventory/posisi-stock-gudang/print",
          name: "PrintPosisiStockGudang",
          component: PrintPosisiStockGudang,
        },
        {
          path: "inventory/laporan-pelunasan-driver",
          name: "LaporanPelunasanDriver",
          component: laporanPelunasanDriver,
        },

        // Distribution Plan
        {
          path: "inventory/distribution-plan",
          component: Layout,
          props: true,
          children: [
            {
              path: "",
              name: "Distribusi Penjualan",
              component: distributionPlanPenjualan,
              props: true,
            },
            {
              path: "service-level",
              name: "Distribusi Service Level",
              component: distributionPlanServiceLevel,
              props: true,
            },
            {
              path: "planed-driver",
              name: "Distribusi Planned Driver",
              component: distributionPlanPlanedDriver,
              props: true,
            },
            {
              path: "report-driver",
              name: "Distribusi Data",
              component: distributionPlanReportDriver,
              props: true,
            },
            {
              path: "jadwal",
              name: "PengirimanPenjualanTerjadwal",
              component: distributionPlanPenjualanTerjadwal,
              props: true,
            },
          ],
        },
        {
          path: "inventory/distribution-plan/delivery-report",
          name: "distributionPlanDeliverReport",
          component: distributionPlan_DeliverReport,
        },
        {
          path: "inventory/rekapitulasi-do",
          name: "rekapitulasiDODriver",
          component: rekapitulasiDODriver,
        },
        {
          path: "inventory/rekapitulasi-do/print",
          name: "printRekapitulasiDODriver",
          component: printRekapitulasiDODriver,
        },
        {
          path: "inventory/realisasi-do",
          name: "distributionPlanReportRealisasiDO",
          component: distributionPlan_ReportRealisasiDO,
        },
        {
          path: "inventory/realisasi-do/print",
          name: "printReportRealisasiDO",
          component: printReportRealisasiDO,
        },

        // End Distribution Plan

        // FINANCE
        // { path: 'finance/pelunasan', name: 'Pelunasan', component: pelunasan },
        {
          path: "finance/data-piutang",
          name: "Piutang",
          component: piutang,
        },
        {
          path: "finance/pelunasan",
          name: "Pelunasan",
          component: pelunasan,
        },
        {
          path: "finance/pelunasan-canvass",
          name: "PelunasanCanvass",
          component: pelunasanCanvass,
        },
        {
          path: "finance/pelunasan-driver",
          name: "PelunasanDriver",
          component: pelunasanDriver,
        },
        {
          path: "finance/pelunasan/print",
          name: "printSemuaInvoice",
          component: printSemuaInvoice,
        },
        {
          path: "finance/rekapitulasi-penagihan",
          name: "RekapitulasiPenagihan",
          component: rekapitulasiPenagihan,
        },
        {
          path: "finance/klaim-retur",
          name: "ReturKlaim",
          component: returKlaim,
        },
        {
          path: "finance/invoice-note",
          name: "Invoice Note",
          component: InvoiceNote,
        },
        {
          path: "finance/form-invoice-note",
          name: "Form Invoice Note",
          component: FormInvoiceNote,
        },
        {
          path: "finance/laporan-ranking-piutang",
          name: "Laporan Ranking Piutang",
          component: laporanRankingPiutang,
        },
        {
          path: "finance/detail-ranking-piutang",
          name: "Detail Ranking Piutang",
          component: detailRankingPiutang,
        },
        {
          path: "finance/surat-tagihan",
          name: "Menu Surat Tagihan",
          component: suratPenagihan,
        },
        {
          path: "finance/surat-tagihan/:id/print",
          name: "Print Surat Tagihan",
          component: printSuratTagihan,
        },

        // PURCHASE
        {
          path: "purchase/data-pembelian",
          name: "Data Pembelian",
          component: DataPembelian,
        },
        {
          path: "purchase/tambah-pembelian",
          name: "Tambah Data Pembelian",
          component: TambahDataPembelian,
        },
        {
          path: "purchase/:id/edit-pembelian",
          name: "Edit Data Pembelian",
          component: EditDataPembelian,
        },
        {
          path: "purchase/pelunasan-pembelian",
          name: "Pelunasan Pembelian",
          component: PelunasanPembelian,
        },

        // EXTERNAL
        {
          path: "external/bridging",
          name: "Bridging",
          component: bridging,
        },
        {
          path: "external/kino-bridging",
          name: "KinoBridging",
          component: kinoBridging,
        },
        {
          path: "external/export-kino",
          name: "ExportKino",
          component: exportKino,
        },
        {
          path: "external/survey-harga",
          name: "SurveyHarga",
          component: surveyHarga,
        },
        {
          path: "external/espt",
          name: "Espt",
          component: espt,
        },
        {
          path: "external/konversi-pajak",
          name: "KonversiPajak",
          component: konversiPajak,
        },
        {
          path: "external/import-nomor-pajak",
          name: "ImportPajak",
          component: importPajak,
        },
        {
          path: "external/rekap-import-pajak",
          name: "ImportRekapPajak",
          component: importRekapPajak,
        },
        {
          path: "external/import-order-san",
          name: "ImportOrderSan",
          component: importOrderSan,
        },
        {
          path: "external/import-order-sosro",
          name: "ImportOrderSosro",
          component: importOrderSosro,
        },
        {
          path: "external/import-order-kino",
          name: "ImportOrderKino",
          component: importOrderKino,
        },
        {
          path: "external/mapping-mars",
          name: "MappingMars",
          component: mappingMars,
        },
        {
          path: "external/export-mars",
          name: "ExportMars",
          component: exportMars,
        },
        {
          path: "external/export-mars-enhanced",
          name: "ExportMarsEnhanced",
          component: exportMarsEnhanced,
        },
        {
          path: "external/bridging-mapping-data",
          name: "BridgingMappingData",
          component: mappingExternal,
        },
        {
          path: "external/dk-import",
          name: "DKImport",
          component: dkImport,
        },
        {
          path: "external/dk-report",
          name: "DKReport",
          component: dkReport,
        },
        {
          path: "external/report-stock-v2",
          name: "ReportStockV2",
          component: reportStockV2,
        },
        {
          path: "external/stt-enhanced",
          name: "SttEnhanced",
          component: sttEnhanced,
        },
        {
          path: "external/konversi-pajak-coretax",
          name: "konversiPajakCoretax",
          component: konversiPajakCoretax,
        },

        // ADMINISTRATOR
        {
          path: "administrator/driver",
          name: "Driver",
          component: driver,
        },
        {
          path: "administrator/api-request-history",
          name: "Api Request History",
          component: apiRequestHistory,
        },
        {
          path: "administrator/kendaraan",
          name: "Kendaraan",
          component: kendaraan,
        },
        {
          path: "administrator/hari-efektif",
          name: "HariEfektif",
          component: hariEfektif,
        },
        {
          path: "administrator/permissions",
          name: "Permissions",
          component: permissions,
        },
        { path: "administrator/role", name: "Role", component: role },
        {
          path: "administrator/group-toko",
          name: "Tambah Grup Toko",
          component: grupToko,
        },
        {
          path: "administrator/data-group-toko",
          name: "Data Grup Toko",
          component: dataGrupToko,
        },
        {
          path: "administrator/users",
          name: "Users",
          component: users,
        },
        {
          path: "administrator/whitelist-outlet",
          name: "Whitelist Outlet",
          component: WhitelistOutlet,
        },
        {
          path: "administrator/reference",
          name: "Reference",
          component: reference,
        },
        {
          path: "administrator/option",
          name: "SelectOption",
          component: SelectOption,
        },
        {
          path: "administrator/akses-principal",
          name: "UserPrincipal",
          component: UserPrincipal,
        },
        {
          path: "administrator/vendor",
          name: "Vendor",
          component: vendor,
        },

        // REPORT
        {
          path: "report/sku",
          component: reportSKU,
        },

        // TESTING
        {
          path: "testing/laporan-sales-to-trade",
          name: "Laporan Sales to Trade Testing",
          component: testingSalesToTrade,
        },
        {
          path: "testing/dashboard",
          name: "Dashboard Testing",
          component: testingDashboard,
        },
        {
          path: "testing/posisi-stock",
          name: "Posisi Stock Testing",
          component: testingPosisiStock,
        },
        {
          path: "testing/faktur-pajak-search",
          name: "Faktur Pajak Search Testing",
          component: testingFakturPajak,
        },
        {
          path: "testing/test",
          name: "New Module Testing",
          component: testingModule,
        },
        {
          path: "approval",
          name: "Approval",
          component: approval,
        },
        {
          path: "billing/waiting",
          name: "BillingWaiting",
          component: billingWaiting,
        },
        {
          path: "billing/history",
          name: "BillingHistory",
          component: billingHistory,
        },
      ],
    },
  ],
});

export default routes;
